import { pxToRem } from "../../../../utils/pxToRem";

export const testimonialCardWrapper = {
  background: "#fff",
  borderRadius: pxToRem(5),
};

export const clientNameText = {
  lineHeight: pxToRem(24),
  fontWeight: 600,
  color: "#12141D",
};

export const socialMediaLinkText = {
  lineHeight: pxToRem(20),
  fontSize: pxToRem(13),
  opacity: ".7",
  color: "#12141D",
};

export const testimonialText = { lineHeight: pxToRem(24), color: "#12141D" };

export const hashtagText = { lineHeight: pxToRem(24), color: "#0EA5E9" };
